import { Typography, Paper } from '@mui/material'
import { useTranslation } from 'react-i18next'
import CheckDetailTitle from './CheckDetailTitle'
import TimelineDotLine from '../components/TimelineDotLine'
import CheckRiskStatus from '../components/CheckRiskStatus'
import '../components/daysLine.scss'

const CheckSerasa = ({ serasaCheck }) => {
  const { t } = useTranslation(['common', 'messages'])
  const details = serasaCheck?.checkDetails?.risco
  const hasChecks = !!details
  const checkLength = hasChecks ? 1 : 0

  const getScore = (score) => {
    if (!score) return null
    if (score.startsWith('2')) return 'success'
    if (score.startsWith('4')) return 'warning'
    if (score.startsWith('6')) return 'error'
    return null
  }

  return (
    <>
      <Paper elevation={0} variant="colorPrimary" sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography>{t('common:serasaScore')}</Typography>
        <CheckRiskStatus checkLength={checkLength} hasChecks={hasChecks} />
      </Paper>

      <CheckDetailTitle
        email={serasaCheck?.email}
        status={serasaCheck?.status}
        createdAt={serasaCheck?.createdAt}
        updatedAt={serasaCheck?.updatedAt}
      />

      {hasChecks && (
        <TimelineDotLine>
          <Paper variant="rootOutlined" elevation={0} sx={{ flex: 1 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '2rem' }}>
              <div className="c-detail-col" style={{ alignItems: 'center' }}>
                <Typography variant="subtitle1">{t('common:score')}</Typography>
                <Typography variant="subtitle3">
                  {details?.score ? (
                    <div className={`trs-circle trs-xl trs-item trs-${getScore(details?.score)}`}>
                      <p className="trs-label">{details?.score}</p>
                    </div>
                  ) : (
                    '---'
                  )}
                </Typography>
              </div>
              <div className="c-detail-col" style={{ alignItems: 'center' }}>
                <Typography variant="subtitle1">{t('common:level')}</Typography>
                <div className={`trs-circle trs-xl trs-item`}>
                  <Typography variant="h2">{details?.nivel ?? '---'}</Typography>
                  <Typography variant="h5">{details?.descricao ?? ''}</Typography>
                </div>
              </div>
            </div>
          </Paper>
        </TimelineDotLine>
      )}
    </>
  )
}

export default CheckSerasa
